import { type MaybeRef, toValue } from 'vue';

import {
  createDomain,
  createDomainRecord,
  deleteDomain,
  deleteDomainRecord,
  updateDomainRecord,
} from './api';
import type { DomainRecordType } from './types';

export const createDomainMutation = () => ({
  mutationFn: (data: Parameters<typeof createDomain>[0]) => createDomain(data),
});

export const createDomainRecordMutation = (domainName: MaybeRef<string>) => ({
  mutationFn: (record: DomainRecordType) => createDomainRecord(toValue(domainName), record),
});

export const updateDomainRecordMutation = (
  domainName: MaybeRef<string>,
  recordId: MaybeRef<number>,
) => ({
  mutationFn: (payload: DomainRecordType) =>
    updateDomainRecord(toValue(domainName), toValue(recordId), payload),
});

export const deleteDomainMutation = () => ({
  mutationFn: (name: string) => deleteDomain(name),
});

export const deleteDomainRecordMutation = (domainName: MaybeRef<string>) => ({
  mutationFn: (recordId: number) => deleteDomainRecord(toValue(domainName), recordId),
});

export const deleteDomainsMutation = () => ({
  mutationFn: (names: string[]) => Promise.all(names.map((name) => deleteDomain(name))),
});
